import { Language } from "src/models";

export const DefaultLanguage: Language = {
  aboutUs: "درباره ما",
  addGiftCode: "افزودن کد هدیه",
  addToHome: "افزودن به خانه",
  addToHomePageTitle: "افزودن به خانه",
  android: "Android",
  androidTvUrl: "https://cafebazaar.ir/app/com.farakav.antentv",
  antenApps: "اپلیکیشن‌های آنتن",
  antenAppsTitle: "اپلیکیشن‌های آنتن",
  antenInstagramLink: "https://www.instagram.com/anten.ir",
  antenPackages: "اشتراک‌های آنتن",
  antenPackagesDescription:
    "با خرید اشتراک‌های آنتن برنامه‌های موردنظر خود را به صورت نامحدود تماشا کنید",
  antenSlogan: "سامانه برخط پخش برنامه های ویدیویی",
  antenTelegramLink: "https://t.me/Anten",
  antenTwitterLink: "https://twitter.com/anten_official",
  antenWebApp: "وب اپلیکیشن آنتن",
  antenWhatsApp: "واتس اپ آنتن",
  antenWhatsAppLink: "https://wa.me/9802187700458",
  appList: "لیست برنامه‌ها",
  archive: "آرشیو",
  archiveList: "لیست آرشیوها",
  archivePageTitle: "آرشیو برنامه‌ها",
  archiveSearchPlaceholder: "جستجو در آرشیو آنتن...",
  archiveUpdating: "آرشیو در حال بروز رسانی می باشد.",
  bazaarUrl: "https://cafebazaar.ir/app/com.farakav.anten/?l=fa",
  bill: "صورت حساب",
  broadcastDate: "تاریخ پخش",
  broadcastTime: "زمان پخش",
  brokenStream: "خرابی لینک",
  buyPackage: "خرید اشتراک",
  buyPackageBannerMessage_Part1: "برای تماشای بدون محدودیت",
  buyPackageBannerMessage_Part2: "اشتراک بخرید",
  cancel: "انصراف",
  capacityExceedMessage: "ظرفیت نمایش تکمیل است.",
  capacityExceedTitle: "",
  captcha: "تاییدیه «من روبات نیستم»",
  cell: "تلفن همراه",
  cellRegexMessage: "{title} باید در فرمت 09XXXXXXXXX باشد",
  cellRequiredMessage: "لطفا شماره تلفن خود را صحیح وارد نمایید",
  channelList: "لیست کانال‌ها",
  chooseYourDay: "روز مورد نظر خود را انتخاب کنید",
  comingSoonMessage: "این برنامه هنوز شروع نشده است",
  comingSoonTitle: "به زودی",
  contactUs: "ارتباط با ما",
  contactUsDescription:
    "ما آماده شنیدن درخواست ها، پیشنهادها، انتقادهای شما هستیم!",
  contactUsFaild:
    "متاسفانه مشکلی در برقراری ارتباط رخ داده است. مجددا تلاش فرمایید.",
  contactUsSent: "پیام شما با موفقیت ثبت شد.",
  copy: "کپی",
  currency: "تومان",
  day: "روز",
  packageDayRemained: "تا {day} روز دیگر فعال است",
  discount: "تخفیف",
  discountApplied:
    "کد تخفیف {code} با موفقیت بر روی صورت حساب شما اعمال شده است.",
  discountCode: "کد تخفیف",
  discountCodePlaceholder: "کد تخفیف را وارد کنید",
  download: "دریافت",
  downloadForSmartTv: "دانلود برای تلویزیون هوشمند",
  downloadFromBazaar: "دانلود از بازار",
  downloadFromMyket: "دانلود از مایکت",
  downloadFromSibApp: "دانلود از سیب‌اپ",
  durationSelect: "انتخاب دوره اشتراک",
  durationSelectDescription:
    "برای ادامه خرید اشتراک یکی از دوره‌های زیر را انتخاب کنید",
  editProfileTitle: "ویرایش حساب کاربری",
  email: "ایمیل",
  emailRegexMessage: "{title} باید ایمیل معتبر باشد",
  enamadLink:
    "https://trustseal.enamad.ir/?id=154499&Code=3XvdSjHQmlg4G5PZfarJ",
  enamadLogo:
    "https://Trustseal.eNamad.ir/logo.aspx?id=154499&Code=3XvdSjHQmlg4G5PZfarJ",
  ended: "تمام شده",
  enterDiscountCodeMessage: "اگر کد تخفیف دارید، در این بخش وارد کنید",
  enterOTP: "لطفا کد پنج رقمی ارسال شده به شماره {cell} را وارد نمایید",
  enterYourCellMessage: "لطفا شماره تلفن خود را وارد نمایید",
  errorOccured: "مشکلی رخ داده است",
  facebook: "فیسبوک",
  forbidenPlayMessage:
    "ای پی شما در محدوده کشور نیست؛ در صورتی که در ایران هستید، از قطع بودن فیلترشکن خود مطمئن شوید.",
  forbidenPlayTitle: "آنتن تنها از داخل ایران قابل استفاده است",
  fullName: "نام و نام خانوادگی",
  fullNamePlaceholder: "نام و نام خانوادگی را وارد کنید",
  giftCode: "کد هدیه",
  giftCodeCopied: "کد هدیه با موفقیت کپی شد",
  giftCodeNotCopied: "امکان کپی کردن کد هدیه وجود ندارد",
  giftCodePlaceholder: "کد هدیه را وارد کنید",
  giftCodeTitle: "وارد کردن کد هدیه",
  guide: "راهنما",
  higherQuality: "کیفیت بالاتر",
  homePage: "صفحه اصلی",
  hour: "ساعت",
  inaccessibility: "عدم دسترسی",
  instagram: "ینستاگرام",
  invalidDiscountCode: "کد وارد شده معتبر نیست",
  ios: "iOS",
  LIVE: "زنده",
  liveBroadcast: "پخش زنده",
  login: "ورود",
  loginDescription:
    "برای مشاهده برنامه‌های آنتن شما نیاز دارید ابتدا وارد حساب کاربری خود شوید و یا در آن ثبت نام کنید",
  loginTitle: "ورود به آنتن",
  logout: "خروج",
  logoutMessage: "آیا با اطمینان قصد خروج از حساب کاربری خود را دارید؟",
  logoutTitle: "خروج از حساب کاربری",
  messageBody: "متن پیام",
  messageBodyPlaceholder: "متن مورد نظر خود را در اینجا بنویسید...",
  minute: "دقیقه",
  more: "بیشتر",
  moreReporter: "گزارشگر بیشتر",
  myketUrl: "https://myket.ir/app/com.farakav.anten",
  myProfile: "حساب کاربری من",
  needPackageMessage: "برای مشاهده این برنامه نیاز به خرید اشتراک دارید.",
  needPackageTitle: "خرید اشتراک",
  noBoughtPackageMessage: "برای تماشای بدون محدودیت اشتراک بخرید",
  noMessageMessage: "پیامی برای نمایش وجود ندارد",
  noPackageDescription:
    "در حال حاضر اشتراک‌ای وجود ندارد.\n\rمی توانید با استفاده از دکمه بارگذاری مجدد، لیست را مجددا بارگذاری کنید.",
  noPackageTitle: "اشتراک‌ای وجود ندارد",
  noProgramMessage: "در حال حاضر برنامه‌ای وجود ندارد",
  noSearchLResult: "نتیجه ای برای عبارت مورد نظر شما یافت نشد.",
  notFound: "متاسفانه صفحه مورد نظر شما یافت نشد",
  notFoundPageTitle: "404",
  notStarted: "شروع نشده",
  orderNumber: "شماره سفارش",
  orderPageTitle: "صورت حساب",
  package: "اشتراک",
  packagedActivated: "این اشتراک تا تاریخ {date} برای شما فعال است",
  packageExpired: "{package} به پایان رسیده است",
  packageExpiry: "{days} روز از اشتراک {package} باقی مانده ",
  packageGuide: "راهنمای خرید اشتراک",
  packagePrice: "قیمت اشتراک",
  packages: "خرید اشتراک",
  packagesPageTitle: "خرید اشتراک آنتن",
  packageType: "نوع اشتراک",
  pay: "پرداخت",
  payableTaxAmount: "مبلغ قابل پرداخت",
  paymentResultPageTitle: "نتیجه پرداخت",
  profile: "پروفایل",
  profilePicFormatError:
    "قالب فایل انتخاب شده نامعتبر است لطفا یک تصویر با فرمت jpg, png یا bmp انتخاب نمایید",
  profilePicSizeError: "حجم فایل انتخابی شما باید کمتر از ۵ مگابایت باشد",
  profileUpdated: "اطلاعات حساب کاربری شما با موفقیت ثبت گردید.",
  profilePromotionTitle: "تکمیل اطلاعات",
  profilePromotionMessage:
    "با تکمیل اطلاعات حساب کاربری، کد تخفیف %1$s دریافت کنید",
  profilePromotionInnerMessage: "10% اشتراک آنتن",
  profilePromotionSubmitText: "تکمیل اطلاعات",
  profilePromotionDismissText: "بعدا یاد آوری کن",
  programList: "لیست برنامه‌ها",
  programPageTitle: "لیست پخش برنامه‌ها",
  pwaAndroidStart:
    "از بالا گوشه سمت راست مرورگر خود گزینه {icon} 'Menu' را انتخاب کنید.",
  pwaGuideTitle: "وب اپلیکیشن آنتن را به صفحه اصلی موبایل خود اضافه کنید.",
  pwaIosStart:
    "از بالا گوشه سمت راست مرورگر خود گزینه {icon} 'Share' را انتخاب کنید.",
  pwaIosStartTip: "مراحل را از نوار پایین شروع کنید",
  pwaSelectAddToHomeScreen:
    "از منوی باز شده گزینه 'Add to home screen' را انتخاب کنید.",
  pwaTapOnAdd: "در مرحله بعد گزینه 'Add' را انتخاب نمایید.",
  rebuy: "خرید مجدد",
  reload: "بارگذاری مجدد",
  checkAgain: "بررسی مجدد",
  retry: "تلاش مجدد",
  errorConnectingServer: "خطا در دسترسی به سرور",
  remainsTillStart: "مانده تا شروع...",
  untillStart: "تا شروع",
  removeDiscount: "حذف کد تخفیف",
  renew: "تمدید",
  reportDescription: "شرح مشکل",
  reportMessage: "لطفا بازخورد خود را با ما به اشتراک بگذارید",
  reportSent: "پیام شما با موفقیت ثبت شد.",
  reportTitle: "ارسال بازخورد",
  requiredMessage: "{title} الزامی است",
  resendOTP: "ارسال مجدد کد",
  resendOTPAfter: "ارسال مجدد کد بعد از",
  return: "بازگشت",
  returnToHome: "بازگشت به صفحه اصلی",
  returnToList: "بازگشت به لیست",
  returnToLive: "بازگشت به پخش زنده",
  returnToProgram: "بازگشت به برنامه",
  samandehiLink:
    "https://logo.samandehi.ir/Verify.aspx?id=99419&p=pfvlpfvlaodsrfthpfvl",
  samandehiLogo:
    "https://logo.samandehi.ir/logo.aspx?id=99419&p=bsiybsiyshwlnbpdbsiy",
  save: "ثبت",
  search: "جستجو",
  second: "ثانیه",
  select: "انتخاب",
  selectAndContinue: "خرید",
  selectSocialNetwork: "شبکه اجتماعی مورد نظر خود را انتخاب کنید",
  send: "ارسال",
  sendOTP: "دریافت کد ورود",
  seoDefaultDescription:
    ".سامانه برخط پخش برنامه های ویدیویی. در این سامانه شما می توانید برنامه های زنده و آرشیو را از طریق وب سایت آنتن یا اپلیکیشن تلفن همراه تماشا کنید",
  seoDefaultKeyword:
    "پخش زنده,پخش مستقیم,اپلیکیشن آنتن,پخش مستقیم بازی ها,پخش اینترنتی بازی های اروپایی",
  seoDescription:
    "پخش زنده آنلاین {title} از وب‌سایت اینترنتی آنتن. شما می‌توانید این برنامه را از طریق اپلیکیشن تلفن همراه و اپلیکیشن تلویزیون‌های هوشمند آنتن نیز تماشا کنید.",
  seoKeyworkd:
    "پخش زنده, پخش زنده آنلاین, پخش آنلاین برنامه {title}, برنامه اینترنتی {title}, دیدن آنلاین {title}",
  share: "اشتراک‌گذاری",
  shareTitle: "پخش {title} 📺 در آنتن، سامانه برخط پخش برنامه‌های ویدیویی",
  sibappUrl: "https://sibapp.com/applications/anten?ios",
  simultaneousPlayMessage:
    "این برنامه در پنجره‌ی دیگه‌ای باز است؛ برای نمایش در این پنجره رو دکمه زیر کلیک کنید.",
  simultaneousPlayTitle: "پخش همزمان",
  smartTv: "تلویزیون هوشمند",
  socialNetworks: "شبکه‌های اجتماعی",
  started: "شروع شده",
  subscriptionEnd: "پایان اشتراک",
  subscriptionPayedPrice: "پرداختی شما",
  subscriptionPrice: "هزینه اشتراک",
  subscriptionStart: "شروع اشتراک",
  successfulPurchase: "خرید موفق",
  successfulPurchaseDescription: "خرید اشتراک با موفقیت انجام شد",
  support: "پشتیبانی",
  supportTell: "(021) 87700458",
  taxAmount: "مالیات بر ارزش افزوده",
  telegram: "تلگرام",
  today: "امروز",
  tommorow: "فردا",
  tvPageTitle: "پخش زنده تلویزیون",
  twitter: "توییتر",
  type: "نوع",
  unauthorizedPlayMessage:
    "برای دسترسی به این برنامه باید وارد حساب کاربری خود شوید.",
  unauthorizedPlayTitle: "ورود به حساب کاربری",
  unsuccessfulPurchase: "خرید ناموفق",
  unsuccessfulPurchaseDescription:
    "به علت مشکل در پرداخت خرید اشتراک انجام نشده است",
  verificationError:
    "کد وارد شده اشتباه است لطفا کد تاییدی که به تلفن همراه شما ارسال شده را وارد نموده و سپس دکمه تایید را فشار دهید",
  verifyOTP: "تایید کد",
  videoEndedMessage: "این برنامه به پایان رسیده است.",
  videoEndedTitle: "پایان برنامه",
  videoLockedMessage: "این برنامه در حال حاضر در دسترس نیست",
  videoLockedTitle: "این ویدیو قفل است",
  videoMissingMessage: "متاسفانه ویدیو مورد نظر یافت نشد.",
  videoMissingTitle: "عدم وجود ویدیو",
  view: "مشاهده",
  watchInThisWindow: "نمایش در این پنجره",
  websiteTitle: "آنتن",
  withAnten: "با آنتن",
  yourMessages: "پیام‌ها",
  yourPackages: "اشتراک‌های من",
  usefullLinks: "لینک‌های مفید",
  purchases: "سوابق پرداخت",
  selectGatewayTitle: "انتخاب درگاه پرداخت",
  selectGatewayDescription: "لطفا درگاه پرداخت را انتخاب کنید",
  activePackages: "اشتراک‌های خریداری شده",
  otherPackages: "اشتراک‌های دیگر",
  youHaveNoPurchases: "شما تاکنون پرداختی نداشته‌اید",
  giftCodeOrLink: "کد یا لینک هدیه",
  purchaseDate: "تاریخ پرداخت",
  packageDuration: "دوره اشتراک",
  start: "شروع",
  end: "پایان",
  showMore: "نمایش بیشتر",
  higherQualitiesNeedPackage:
    "با خرید اشتراک می توانید این برنامه را با کیفیت {quality} و بالاتر تماشا کنید",
  qualities: "کیفیت‌ها",
  detail: "امکانات",
  durationRenew: "تمدید دوره اشتراک",
  durationRenewDescription:
    "برای ادامه تمدید اشتراک یکی از دوره‌های زیر را انتخاب کنید",
  yourSelectedPackage: "اشتراک انتخابی شما",
  feedback_suggestions: "پیشنهادات و انتقادات",
  feedback_marketing: "تبلیغات و مارکتینگ",
  feedback_support: "پشتیبانی",
  feedback_chooseFeedbackType: "واحد مربوطه را انتخاب کنید",
  feedback_feedbackType: "واحد مربوطه",
  button_check_ip: "بررسی بیشتر",
  devices: "دستگاه‌ها",
  deviceType: "عنوان",
  deviceRegisterDate: "تاریخ اولین فعالیت",
  status: "وضعیت",
  currentDevice: "دستگاه فعلی",
  terminateAllAccesses: "قطع دسترسی سایر دستگاه‌ها",
  terminateAccess: "قطع دسترسی",
  restoreAccess: "اتصال دستگاه فعلی",
  deviceHasAccess: "فعال",
  deviceHasNotAccess: "قطع",
  deviceTerminatedTitle: "قطع دسترسی دستگاه",
  deviceTerminatedMessage: "دسترسی توسط دارنده دستگاه قطع شده است",
  messageModalButton: "متوجه شدم",
  gender: "جنسیت",
  genderPlaceholder: "جنسیت را انتخاب کنید",
  male: "مرد",
  female: "زن",
  birthday: "تاریخ تولد",
  birthdayPlaceholder: "روز /  ماه /  سال",
  favorites: "علاقه‌مندی‌های من",
  edit: "ویرایش",
  completeProfileTitle: "تکمیل اطلاعات",
  completeProfileMessage:
    "برای استفاده از بهتر از امکانات اپلیکیشن آنتن، لطفا اطلاعات حساب کاربری خود را تکمیل کنید.",
  completeProfileButton: "تکمیل اطلاعات",
  add: "افزودن",
  remove: "حذف",
  noFaveResult: "برای «{term}» موردی یافت نشد.",
  addFavoriteSports: "افزودن ورزش‌های مورد علاقه",
};
